import React, { useState, useEffect } from "react"
import { Link, navigate } from "gatsby"
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { PrimaryButton, MessageBar, MessageBarType } from 'office-ui-fabric-react';

import { LANDING_URL } from '../models/api';
import UserModel from "../models/user"
import UsertokenModel from "../models/account";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";


const LoginForm = ({
  setAuthState,
  cancelLogin,
  setAccount,
  state,
}) => {
  const [email, setEmail] = useState("")
  const [pass, setPass] = useState("")
  const [error, setError] = useState(null)
  const [busy, setBusy] = useState(false)

  // Select account
  const [isSelectAccountFormVisible, setIsSelectAccountFormVisible] = useState(false);
  const [isAccountsFetching, setIsAccountsFetching] = useState(false);
  const [accountsOptions, setAccountsOptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState({});

  const model = new(UserModel);
  const accountModel = new(UsertokenModel);

  /**
   * submit
   * @param e
   */
//   const submit = (e) => {
//     e.preventDefault();
//     setBusy(true);
//     setError(null);

//     if (email.length === 0) {
//       setError("Email can't be empty")
//       return
//     }

//     if (pass.length === 0) {
//       setError("Password can't be empty")
//       return
//     }

//     model.signin(email, pass).then(r => {
//       if (r.data.activated === false) {
//         window.location.href = `/activate?t=${r.data.user}___${r.data.token}`
//       }

//       //console.log(r)

//       let authState = {
//         isAuthenticated: true,
//         user: email,
//         accessToken: r.data.access,
//         refreshToken: r.data.refresh
//       }

//       setAuthState(authState)
      
//       setIsSelectAccountFormVisible(true);
//       //navigate("/dashboard")

//     }).catch(err => {
// //      console.log(JSON.stringify(err))
//       setError(err.message ? err.message : err);
//       setPass("");
//     }).then(() => setBusy(false))
//   }

  const initializeUser = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const logoutWP = urlParams.get('wpoauth');
    const access = urlParams.get('access');
    const refresh = urlParams.get('refreshToken');
    const email = urlParams.get('email');

    if (!!logoutWP) {
      window.location.href = `${LANDING_URL}wp-json/wpoauth/v1/logout/`
      return;
    }

    // if (urlParams.get('changeUser') && access) {
    //   setIsSelectAccountFormVisible(true);
    // } else 
    
    if(!email || !access || !refresh) {
      window.location.href = `${LANDING_URL}?login=1`;
      return;
    }

    model
    .refreshToken(access)
    .then(r => {
      let authState = {
        isAuthenticated: true,
        user: email,
        accessToken: r.data.token,
        refreshToken: refresh
      }
      setAuthState(authState)

      setIsSelectAccountFormVisible(true);
    })
    .catch(() => {
      window.location.href = `${LANDING_URL}?error=Something+went+wrong,+please+try+to+log+in+later`;
    })

  }

  const handleSelectAccount = (account) => {
    let accountPayload = {
      accountEmail: account.email,
      accountID: account.id,
      accountKind: account.kind
    }

    setAccount(accountPayload);
    setIsSelectAccountFormVisible(false);
    navigate("/dashboard");
  }

  useEffect(() => {
    async function fetchAccounts() {
      setIsAccountsFetching(true);
      try {
        const res = await accountModel.fetchAccounts(state.accessToken);

        setIsAccountsFetching(false);

        if (res.data.length && res.data.length === 1) {
          handleSelectAccount(res.data[0]);
        } else if (res.data.length && res.data.length > 1) {
          setAccountsOptions(accountsOptions => [...res.data]);
        }
      } catch (err) {
        setIsAccountsFetching(false);
        console.log(err)
      }
    }

    if (isSelectAccountFormVisible) {
      fetchAccounts();
    }

  }, [isSelectAccountFormVisible])

  useEffect(() => {
    initializeUser();
  }, []);

  return (
    <>
    {/* <form style={s.form} onSubmit={(e) => submit(e)}>
      <h3>Login</h3>
      <TextField placeholder="your@email.org"
                 styles={{root: s.input}}
                 value={email}
                 disabled={busy}
                 onChange={(e) => setEmail(e.target.value)} />

      <TextField type="password"
                 placeholder="password"
                 styles={{root: s.input}}
                 value={pass}
                 disabled={busy}
                 onChange={(e) => setPass(e.target.value)} />

      {error !== null ?
        <MessageBar messageBarType={MessageBarType.error}
                    styles={{root:s.input}}
                    isMultiline={true}
                    onDismiss={() => {
                      setError(null);
                      setBusy(false);
                    }}
                    dismissButtonAriaLabel="Close">
          {error}
        </MessageBar>
        : null
      }

      <PrimaryButton text="Login"
                     type="submit"
                     styles={{root: s.input}}
                     disabled={busy}
                     onClick={(e) => submit(e)} />
      <Link to="/register/" style={s.link}>Create a new account</Link>
    </form> */}

    {/* Select account dialog */}
    <Dialog open={accountsOptions.length}>
      <DialogTitle>Select account</DialogTitle>
      <DialogContent>
        {
          !isAccountsFetching && accountsOptions && accountsOptions.length > 0
          ?
          <FormControl component="fieldset">
            <RadioGroup onChange={(e) => {
              setSelectedAccount(JSON.parse(e.target.value));
            }}>
              {
                accountsOptions.map(option => (
                  <FormControlLabel
                    key={option.id}
                    value={JSON.stringify(option)}
                    control={<Radio/>}
                    label={`${option.email} ${option.kind}`}
                  />
                ))
              }
            </RadioGroup>
          </FormControl>
          :
          <div style={{display: 'flex', justifyContent: 'center'}}>
          <CircularProgress />
          </div>
        }
      </DialogContent>
      <DialogActions>
        <Button 
          autoFocus 
          color="primary" 
          disabled={isAccountsFetching || !selectedAccount.id}
          onClick={() => handleSelectAccount(selectedAccount)}
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
    </>
  )
}

export default LoginForm

const s = {
  form: {
    border: "1px solid #777",
    borderRadius: "10px",
    minWidth: "350px",
    minHeight: "150px",
    display: "block",
    padding: "15px 10px",
    textAlign: "left"
  },
  input: {
      marginBottom: "10px"
  },
  link: {
    fontSize: "10pt",
    color: "#555",
    marginLeft: "30px",
    position: "relative",
    top: "5px"
  }
}